import React from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { isValidTenant, TenantCode } from '../config';
import { TenantContext } from '../context/TenantContext';

export const TenantLayout: React.FC = () => {
    const { inviteCode } = useParams<{ inviteCode: string }>();

    if (!inviteCode || !isValidTenant(inviteCode)) {
        // Option 1: Redirect to a 404 page or a generic landing page
        // Option 2: Fallback to a default tenant? No, bad security practice.
        return <Navigate to="/404" replace />;
    }

    const value = {
        tenantCode: inviteCode as TenantCode
    };

    return (
        <TenantContext.Provider value={value}>
            <Outlet />
        </TenantContext.Provider>
    );
};
